<template>
  <div id="popups">
    <!-- Content -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader class="py-3">
            <h4 class="mb-0">Contato</h4>
          </CCardHeader>
          <CCardBody>
            <!-- Search -->
            <CRow>
              <CCol col="12">
                <Search @search="updateSearch" />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="12">
                <CRow>
                  <!-- Status -->
                  <CCol md="4" lg="4" xl="3">
                    <div class="form-group">
                      <Multiselect
                        :value="
                          languageOptions.find(
                            (option) => option.value == query.language
                          )
                        "
                        :options="languageOptions"
                        label="label"
                        track-by="value"
                        placeholder="Idioma"
                        @select="
                          (selected) => (query.language = selected.value)
                        "
                      />
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <!-- Datatable -->
            <CRow>
              <CCol col="12">
                <DataTable
                  :sorter="query.sorter"
                  :items="datatable.items"
                  :fields="datatable.fields"
                  :enable-export="false"
                  base-route="/contact/edit/"
                  @sorterValue="(event) => (query.sorter = event)"
                  @row-clicked="handleRowClick"
                  @update:checked="updateStatus"
                >
                  <template #actions="{ id }">
                    <DatatableEdit :url="`/contact/edit/${id}`" />
                  </template>
                </DataTable>
              </CCol>
            </CRow>

            <!-- Pagination -->
            <CRow class="mt-2">
              <CCol lg="12">
                <Pagination
                  :page="query.page"
                  :per-page="query.perpage"
                  :pages="pagination.pages"
                  :total="pagination.total"
                  :items="pagination.items"
                  @update:active-page="(page) => (query.page = page)"
                  @update:perpage="(perpage) => (query.perpage = perpage)"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
// Components
import DataTable from '@/components/ui/Datatable'
import DatatableEdit from '@/components/ui/DatatableActions/Edit'
import Pagination from '@/components/ui/Pagination'
import Search from '@/components/ui/Search'
import Multiselect from '@/components/ui/Multiselect'

// Services
import Service from '@/services/contact.service'

export default {
  metaInfo: {
    title: 'Contato',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_contacts')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    DataTable,
    DatatableEdit,
    Pagination,
    Search,
    Multiselect
  },

  data() {
    return {
      datatable: {
        items: [],
        fields: [
          {
            key: 'name',
            label: 'Nome',
            _style: 'width: 20%;',
            sorter: false
          },
          {
            key: 'email',
            label: 'Email',
            _style: 'width: 20%;',
            sorter: false
          },
          {
            key: 'phone',
            label: 'Telefone',
            _style: 'width: 20%;',
            sorter: false
          },
          {
            key: 'dateFormated',
            label: 'Data de envio',
            _style: 'width: 20%;',
            sorter: false
          },
          {
            key: 'language',
            label: 'Idioma',
            sorter: false
          },
          {
            key: 'actions',
            label: 'Ações',
            sorter: false,
            _style: 'width: 12%; min-width: 0px'
          }
        ]
      },
      query: {
        search: '',
        page: 1,
        perpage: localStorage.getItem('perPageItem')
          ? parseFloat(localStorage.getItem('perPageItem'))
          : 10,
        language: null,
        pagination: true,
        sorter: {
          asc: false,
          column: ''
        }
      },
      pagination: {
        total: 0,
        pages: 0,
        items: 0
      },
      languageOptions: [
        {
          label: 'Todos os idiomas',
          value: null
        },
        {
          label: 'Português',
          value: '1'
        },
        {
          label: 'Inglês',
          value: '2'
        },
        {
          label: 'Espanhol',
          value: '3'
        }
      ],
      rowCliked: {}
    }
  },

  watch: {
    query: {
      handler: 'updateDataTable',
      deep: true
    },
    language: {
      handler: 'updateDataTable'
    }
  },

  async created() {
    await this.updateDataTable()
  },

  methods: {
    async updateDataTable() {
      const response = await Service.index(this.query)
      const { data, pagination } = response

      if (data) {
        this.pagination = {
          ...pagination,
          pages: pagination.lastPage,
          items: data.length
        }

        const newItems = response.data.map((item) => {
          return {
            ...item
          }
        })

        this.datatable.items = newItems
      }
    },

    async updateSearch(searchText) {
      this.query.search = searchText
      this.query.page = 1

      await this.updateDataTable()
    },

    handleRowClick(event) {
      this.rowCliked = event
    },

    async updateStatus(event) {
      console.log(event)
      // const response = await InstitutionalService.updateStatus(this.rowCliked, event)

      // if (response.status === 200) {
      //   this.$notify({
      //     group: 'notifications',
      //     type: 'success',
      //     text: 'Status alterado com sucesso'
      //   })
      //   await this.updateDataTable()
      // } else {
      //   this.$notify({
      //     group: 'notifications',
      //     type: 'error',
      //     text: 'Ocorreu um erro ao atualizar o status, por favor tente novamente!'
      //   })
      // }
    }
  }
}
</script>

<style lang="scss"></style>
